import { useState, useEffect } from 'react';
import axios from 'axios';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid';
import { Search16w } from '../../../images/icons/icons_component';

function JunsongDetail_popup() {

    const sendData = JSON.parse(localStorage.getItem('junsong'));
    const [searchParams, setSearchParams] = useState({
        emogcode: sendData.emogcode,
        searchGrdc: sendData.searchGrdc,
        searchFromdate: sendData.searchFromdate,
        searchDateCls: sendData.searchDateCls,
        searchTodate: '',
    });
    const dataHead = ['No.', '내원일자', '시간', '등록번호', '이름', '나이/성별', '주진료과', '주증상', '진료결과', '상태', '면허번호', '발병일자', '발병시간', '내원사유 (질병여부)', '내원사유 (의도성)', '내원사유 (손상기전)', '내원경로', '내원수단', '응급증상유무', '환자내원시반응', '수축기혈압', '이완기혈압', '분당맥박수', '분당호흡수', '체온', '퇴실일자', '퇴실시간', '입원후결과', '퇴원일자', '퇴원시간', '기타증상', '교통사고당사자', '안전벨트', '아동용좌석', '전면에어백', '측면에어백', '헬멧', '무릎및관절보호대', '전혀착용안함', '비해당', '미상', '검사처치', '퇴실진단', '퇴원진단', '수술']; //component화 
    const dataColumn = ['SEQ', 'PTMIINDT', 'PTMIINTM', 'PTMIIDNO', 'PTMINAME', 'PTMIBRXX', 'PTMIDEPTDESC', 'PTMIMNSYCHCO', 'PTMIEMRTDESC', 'PTMISTATDESC', 'PTMIDRLC', 'PTMIAKDT', 'PTMIAKTM', 'PTMIDGKDDESC', 'PTMIARCFDESC', 'PTMIARCSDESC', 'PTMIINRTDESC', 'PTMIINMNDESC', 'PTMIEMSY', 'PTMIRESPDESC', 'PTMIHIBP', 'PTMILOBP', 'PTMIPULS', 'PTMIBRTH', 'PTMIBDHT', 'PTMIOTDT', 'PTMIOTTM', 'PTMIDCRTDESC', 'PTMIDCDT', 'PTMIDCTM', 'PTMIETSYDESC', 'PTMITAIP', 'PTMITSBT', 'PTMITSCS', 'PTMITSFA', 'PTMITSSA', 'PTMITSHM', 'PTMITSPT', 'PTMITSNO', 'PTMITSUR', 'PTMITSUK', 'TRCDDESC', 'DGOTDESC', 'DGDCDESC', 'OPPTDESC'];
    const apiCall = '/ptmiapi/nedis/tonggyeweb/bdtongjunsunghyunhwangDetail_search.do';
    const apiCntCall = '';
    const excelFileName = '기관별_전담전문의 별 당직일수';
    const excelHead = [];
    const mergeConfig = [{ key: 'EMOGDESC', row: null }, { key: 'MONTH' }, { key: 'CLNICKWA_NM' }, { key: 'DEPT_DUTY_CNT' }];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false,
        loadingHeight: '6rem'
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    const search = async () => {
        try {
            setState((prev) => ({
                ...prev,
                isLoading: true,
            }));
            const response = await axios.get(apiCall, {
                params: searchParams,
            });
            setState((prev) => ({
                ...prev,
                dataList: response.data,
                isSearched: true,
                isLoading: false,
            }));
            setPageInfo((prev) => ({
                ...prev,
                totalItems: response.data.length,
            }))
            console.log(response.data);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    useEffect(() => {
        search();
    }, []);

    return (
        <div className='popup_container bg_st_bg'>
            <h5>응급환자 표준진료정보 세부 전송 내역</h5>
            <div className='flex flex-col overflow-auto h-full'>
                <div className="com-search st_pop_th_bg" style={{ borderTop: 'var(--st-primary-border' }}>
                    <table>
                        <colgroup>
                            <col width="10%" />
                            <col width="20%" />
                            <col width="10%" />
                            <col width="20%" />
                            <col width="10%" />
                            <col width="20%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>기관명</th>
                                <td>
                                    <input
                                        type="text"
                                        name="searchGrdc"
                                        value={searchParams.searchGrdc}
                                        readOnly={true}
                                    />
                                </td>
                                <th>전송일자</th>
                                <td>
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <input
                                            type="text"
                                            name="searchFromdate"
                                            value={searchParams.searchFromdate}
                                            readOnly={true}
                                        />
                                        <input
                                            type="text"
                                            name="searchDateCls"
                                            value={searchParams.searchDateCls}
                                            readOnly={true}
                                        />
                                    </div>
                                </td>
                                <th>내원일자</th>
                                <td>
                                    <input
                                        type="date"
                                        name="searchTodate"
                                        value={searchParams.searchTodate}
                                        onChange={handleInputChange}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='search_btn_wrapper'>
                    <span className='total_items'>전체&nbsp;<strong className='st_primary'>{pageInfo.totalItems}</strong>건</span>
                    <div className='btn_container'>
                        <button onClick={search} className='search_btn bg_st_primary' disabled={state.isLoading}><Search16w />조회</button>
                    </div>
                </div>
                <div className='st_pop flex flex-col flex-grow min-h-0'>
                    <NewDataGrid
                        propsInfo={propsInfo}
                        state={state}
                        pageInfo={pageInfo}
                        setPageInfo={setPageInfo}
                        mergeConfig={mergeConfig}
                    />
                </div>
            </div>
        </div>
    );
}

export default JunsongDetail_popup;